import { useMemo } from 'react';
import { Element, Icon } from 'react-bulma-components';
import { FaCheck } from 'react-icons/fa6';
import If from '../if/if';
import styles from './task-tag.module.scss';

export type TaskTagProps = {
  taskContent?: string;
  pending?: boolean;
};

export function TaskTag({ taskContent, pending }: TaskTagProps) {
  const containerBackgroundColor = useMemo(() => {
    if (taskContent) {
      return pending ? 'danger-light' : 'success-light';
    }
    return 'transparent';
  }, [pending, taskContent]);

  const contentClassName = useMemo(() => {
    let defaultClassName = `has-text-weight-light ${styles.content}`;

    if (pending) {
      defaultClassName += ' has-text-danger-dark';
    } else {
      defaultClassName += ' has-text-success-dark';
    }

    return defaultClassName;
  }, [pending]);

  return (
    <Element
      display="flex"
      alignItems="center"
      backgroundColor={containerBackgroundColor}
      className={styles.container}
    >
      <If condition={!pending}>
        <Icon color="success-dark">
          <FaCheck />
        </Icon>
      </If>
      <If condition={!!taskContent}>
        <span className={contentClassName}>{taskContent}</span>
      </If>
    </Element>
  );
}

export default TaskTag;
